// SummarizeButton.tsx
import React, { useEffect, useState } from 'react';
import '../../styles/css/header.css';
import { SummarizeIcon } from '../Icons/SummarizeIcon';
import { useSelector } from 'react-redux';
import { IStore } from '../../redux/store/IStore';
import Tooltip from "@material-ui/core/Tooltip";

interface IProps {
    handleSummaryButtonClick: () => void;
}

export const SummarizeButton = ({ handleSummaryButtonClick }: IProps) => {
    const [anchorEl, setAnchorEl] = React.useState<SVGSVGElement | null>(null);
    const summaryExists = useSelector((state: IStore) => state.summaryExists);
    const summarizingInProgress = useSelector((state: IStore) => state.summarizingInProgress);

    const [activeBullet, setActiveBullet] = useState<number>(1);

    useEffect(() => {
        if (summarizingInProgress) {
            const interval = setInterval(() => {
                setActiveBullet((prev) => (prev < 3 ? prev + 1 : 1));
            }, 300); // Change the active bullet every 300ms
            return () => clearInterval(interval); // Cleanup on stop
        } else {
            setActiveBullet(0); // Set to 0 (no animated bullets) when summarizing stops
        }
    }, [summarizingInProgress]);


    const onMouseEnter = (event: React.MouseEvent<SVGSVGElement>) => {
        setAnchorEl(event.currentTarget); // event.currentTarget is the SVG element
    };

    const onMouseLeave = (event: React.MouseEvent<SVGSVGElement>) => {
        setAnchorEl(null);
    };

    return (
        <>
            <Tooltip title="Povzetek" placement="top" arrow={true}>
                <button
                    onClick={handleSummaryButtonClick}
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <SummarizeIcon
                        className="icon_button"
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}
                        style = {{
                            fill: summaryExists ? '#2B8DFF' : '#CCCCCC',
                        }}
                        activeBullet={activeBullet} // Pass active bullet (used only when summarizingInProgress = true)
                        summarizingInProgress={summarizingInProgress} // Pass whether "loading" is happening
                        outlineColor={summaryExists ? '#2B8DFF' : '#CCCCCC'} // Match outline color
                        viewBox="0 0 48 48"
                    />

                </button>
            </Tooltip>
        </>
    );
};